"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertObject = void 0;
exports.upsertObject = {
    upsertObject_title: "Новый пункт",
    upsertObject_objectTypeSelectTitle: "Выберите тип площадки",
    upsertObject_submit: "Отправить на модерацию",
    upsertObject_containersCount: "Количество контейнеров",
    upsertObject_containersTitle: "Стандартные",
    upsertObject_specialContainersTitle: "Специальные",
    upsertObject_selectPoint: "Выберите точку на карте",
    upsertObject_addressRequired: "Необходимо указать адрес",
    upsertObject_startAtRequired: "Необходимо указать дату старта",
    upsertObject_endAtRequired: "Необходимо указать дату завершения",
    upsertObject_endAtInvalid: "Укажите дату больше даты старта",
    upsertObject_contacts: "Контактная информация",
    upsertObject_finishTitle: "Спасибо!",
    upsertObject_finishMessage: "В ближайшее время модераторы\n	проверят вашу заявку",
    upsertObject_finishEditMessage: "Данные успешно сохранены",
};
//# sourceMappingURL=upsertObject.js.map